<header
    class="w-full border-b border-gray-100 bg-app-background-10 sticky top-0 z-50 transition-all duration-300 py-5"
>
    <div
        class="max-w-[1400px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 transition-all duration-300"
    >

        <!-- Left: Termin -->
        <div class="flex-1 flex justify-start">
            <button class="flex items-center gap-2 text-sm text-gray-500 hover:text-app-primary-10 transition-colors group" (click)="routeToLogin()">
                <app-icon name="appointment" class="w-[18px] h-[18px] text-app-secondary-10 group-hover:scale-110 transition-transform"></app-icon>
                <span>Termin vereinbaren</span>
            </button>
        </div>

        <!-- Center: Logo -->
        <div class="flex flex-col items-center justify-center cursor-pointer" routerLink="/">
            <img src="assets/logo/logo.svg" alt="Logo" class="logo">
        </div>

        <!-- Right: Login & Kontakt -->
        <div class="flex-1 flex justify-end gap-8 text-sm text-gray-500">
            <button class="flex items-center gap-2 hover:text-app-primary-10 transition-colors group" (click)="routeToLogin()">
               <app-icon name="user" class="w-[18px] h-[18px] text-app-primary-20 group-hover:scale-110 transition-transform"></app-icon>
                <span>Login</span>
            </button>
            <button class="flex items-center gap-2 hover:text-[#3a5343] transition-colors group" routerLink="/kontakt">
                <app-icon name="mail" class="w-[18px] h-[18px] text-app-primary-20 group-hover:scale-110 transition-transform"></app-icon>
                <span>Kontakt</span>
            </button>
        </div>
    </div>
</header>
